import { IQueryContext } from 'framework/context/IQueryContext';
import { ICustomerAccount, ICustomerAccountQueryMetadata, ICustomerAccountsQueryParams, IQueryResultWithMetadata } from 'gen/ApiClient';
import React from 'react';

export const QueryContext = React.createContext<
	IQueryContext<IQueryResultWithMetadata<ICustomerAccount, ICustomerAccountQueryMetadata>, ICustomerAccountsQueryParams>
>(undefined as any);
